import { BrowserRouter } from 'react-router-dom';
import { ChakraProvider, theme } from '@chakra-ui/react';
import RouteApp from './components/RouteApp';
import ErrorBoundary from './components/error/ErrorBoundary';

function App() {
    return (
        <ErrorBoundary>
            <ChakraProvider theme={theme}>
                <BrowserRouter>
                    <RouteApp/>
                </BrowserRouter>
            </ChakraProvider>
        </ErrorBoundary>
    );
}

export default App;
